var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartRed = function SvgHeartRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6723 26.5724C45.8294 23.0879 46.5313 18.7709 45.593 14.7569C43.5884 5.6136 32.4879 1.87741 25.5734 8.00473C25.0259 8.48675 24.5389 9.04247 24 9.59658C23.4612 9.04248 22.9741 8.48675 22.4266 8.00473C15.5121 1.87741 4.41161 5.6136 2.407 14.7569C1.46876 18.7709 2.17054 23.0879 4.3277 26.5724C8.10241 32.6795 14.189 37.435 20.1264 41.7447C22.4322 43.4184 25.5679 43.4184 27.8737 41.7447C33.8111 37.435 39.8976 32.6795 43.6723 26.5724Z",
    fill: "#BE123C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1143 10.9919C32.5486 9.5207 34.0932 8.68011 35.5643 9.11434C38.4217 9.95772 40.8698 12.2024 41.8714 15.389C42.3314 16.8523 41.518 18.4115 40.0547 18.8714C38.5914 19.3314 37.0323 18.518 36.5723 17.0547C36.1374 15.671 35.113 14.7728 33.9919 14.4419C32.5207 14.0076 31.6801 12.463 32.1143 10.9919Z",
    fill: "#FDA4AF"
  })));
};
export default SvgHeartRed;